
import {defineComponent, onMounted, ref} from 'vue';
import {OioButton, OioDateTimePicker, OioForm, OioFormItem, OioModal} from '@kunlun/vue-ui-antd';
function getPreviousThreeMonths(): string[] {
  const months: string[] = [];
  const baseDate = new Date(); // 使用副本避免修改原日期

  for (let i = 0; i < 3; i++) {
    // 计算目标年月
    const targetMonth = baseDate.getMonth() - i;
    const targetYear = baseDate.getFullYear() + Math.floor(targetMonth / 12);
    const actualMonth = ((targetMonth % 12) + 12) % 12; // 确保月份在 0-11 范围内

    // 格式化月份为两位数
    const formattedMonth = (actualMonth + 1).toString().padStart(2, '0');
    months.push(`${targetYear}${formattedMonth}`);
  }

  return months;
}


export default defineComponent({
    name: 'customizeView',
    inheritAttrs: false,
  components: {OioButton, OioDateTimePicker, OioForm, OioFormItem, OioModal},
    props: {
      submitData: {
        type: Function,
        required: true
      },
    },
  setup(props) {
    const dateList = ref<string[]>([]);
    const selectValue = ref("");
    const visible = ref(false);
    const submit = () => {
      props.submitData(selectValue.value).then(res=>{
        cancel();
      });
    }

    const cancel = () => {
      visible.value = false;
    }

    onMounted(() => {
      dateList.value = getPreviousThreeMonths();
      selectValue.value = dateList.value[0];
    });


    return {
      dateList,
      selectValue,
      submit,
      visible,
      cancel
    };
  }
});
